import { Icon } from "../../../components/BaseComponents/Icon";

export const ClockIcon = (props) => (
	<Icon viewBox="0 0 24 24" fill="none" {...props}>
		<path
			xmlns="http://www.w3.org/2000/svg"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M12 8v4l3.5 2m4.5-2a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
		/>
	</Icon>
);
